/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit CheckSelected.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Check from 'DesignSystem/Svgs/Check/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  backgroundColor: "rgba(0,207,104)",
borderBottomLeftRadius: 10,
borderBottomRightRadius: 10,
borderTopLeftRadius: 10,
borderTopRightRadius: 10,
paddingBottom: 2,
paddingLeft: 2,
paddingRight: 2,
paddingTop: 2,
  opacity: 'var(--opacity)'})

export default function CheckSelected({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  opacity= 1
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="CheckSelected.Vertical"
 data-view-path={dataViewPath}
 style={{'--opacity': opacity}}
 className={`views-block ${styles.Vertical}`}
>
<Check
 data-testid="CheckSelected.Check"
 data-view-path={dataViewPath}
 width={10}
 height={10}
 stroke="white"
/>
</div>
{children}
</React.Fragment>)
}